<template>
	<div style="">

		<!-- sök kategori -->
		<div>

			<div style="margin-bottom:10px;padding:0px;margin-left:5px;">
				<div class="form textField" style="width:50%;">
					<input type="text" v-model="this.filter" placeholder="Sök bland kategorier" />
					<img src="@/assets/w3_button_close_light.png" @click="this.filter = ''">
				</div>



			</div>

			<!-- sök kategori resultat -->
			<div v-if="this.filter" style="">
				<div style="max-height:300px;overflow:scroll;">
					<div v-for="category in this.categoryListSearch" :key="category.categoryId"
						style="padding:5px;background: var(--grey-2);margin-bottom:5px;border-radius: 5px;padding:10px;"
						@click.stop="this.searchCategoryIdSelected(category.categoryId)" class="flexcenter link"
						:title="'Klicka för att visa produkter i kategori:  ' + category.path ">
						<div style="flex-grow:1;">{{ category.path }}</div>

						<Icon fileName="w3_chevron_right_light" style="height:25px;width:15px;margin-left:10px;" />
					</div>

				</div>
			</div>

			<!-- start category grid med bilder -->
			<div style="border:0px solid red;padding:0px;">

				<div v-if="!this.filter && this.selectedStartCategory == null" id="startCategoryGrid" class="flexcenter"
					style="width:100%;">

					<div v-for="category in this.sortCategoryList(this.startCategoryGrid)" :key="category.categoryId"
						style="padding-bottom:10px;padding-left:5px;padding-right:5px;"
						@click="this.selectedStartCategory = category" class="link">

						<Card :cardtitle="category.name"  
							@click="this.selectedStartCategory = category"
							:filename="this.cateogryIdImageList.includes(category.categoryId) ? 'category_' + category.categoryId + '.jpg': null "
							:title="'Visa produkter i kategori: '  + category.path + ', id: ' + category.categoryId "
							style="" :tint="true" mode="dark" fontSizeTitleMax="140%" class="card"/>
					</div>
				</div>

				<div v-if="!this && !this.filter && this.selectedStartCategory == null" id="startCategoryGrid" class="flexcenter"
					style="width:100%;flex-wrap:wrap;gap:0px;">

					<div v-for="category in this.sortCategoryList(this.startCategoryGrid)" :key="category.categoryId"
						style="padding-bottom:10px;padding-left:5px;padding-right:5px;"
						@click="this.selectedStartCategory = category" class="link">

						<div class="flexcenter"
							style="flex-direction:column;box-shadow: rgba(25, 25, 25, 0.2) 0px 4px 10px 0px;background:var(--grey-1);border-radius:10px;">

							<div class="cateBox" style="border-radius: 10px 10px 0px 0px;">

							</div>

							<div class="flexcenter" @click="this.selectedStartCategory = category" style="padding:10px;">
								<b :title="'ID: ' + category.categoryId">{{ category.name }}</b>

							</div>

						</div>




					</div>
				</div>

				<!-- start category grid low -->
				<div v-if="!this.filter && this.selectedStartCategory" style="align-items: start;" class="flexcenter">

					<div style="margin-top:5px;">
						<Icon fileName="w3_chevron_left_light" style="height:20px;width:10px;"
							@click="this.selectedStartCategory = null" />
					</div>

					<div id="startCategoryGridLow" class="flexcenter"
						style="width:100%;overflow:scroll;gap:5px;padding-bottom:10px;flex-wrap:wrap;">


						<div v-for="category in this.sortCategoryList(this.startCategoryGrid)" :key="category.categoryId"
							style="padding:10px;padding:5px;" @click="this.selectedStartCategory = category" class="link"
							:class="category.categoryId == this.selectedStartCategory?.categoryId ? 'selected' : '' ">
							<div style="white-space:nowrap;">{{ category.name }}</div>
						</div>
					</div>
				</div>

			</div>

		</div>

		<!-- category view -->
		<div v-if="!this.filter" style="border:0px solid orange;align-items: start;" class="flexcenter">





			<div v-if="this.selectedStartCategory" style="background:transparent;flex-grow:1;">

				<div style="margin-bottom:5px;" class="flexcenter link" @click="this.setCategory(this.selectedStartCategory)"
					:title="'Visa alla produkter i kategori: ' + this.selectedStartCategory?.name ">

					<span style="font-size:80%;font-weight:bold;">{{ this.selectedStartCategory?.name }} </span>
					<Icon fileName="w3_chevron_right_dark" style="height:10px;width:6px;margin-left:2px;" />

				</div>


				<!-- grid med snabblänkar -->
				<div id="selectedStartCategoryGrid" style="flex-wrap:wrap;border-bottom:1px solid var(--grey-3);" class="flexcenter">

					<div v-for="category in this.sortCategoryList(this.selectedStartCategory?.categoryList)" :key="category.categoryId"
						style="padding:0px;margin-bottom:5px;font-size:100%;border-radius: 5px;"
						@click="this.setSelectedCategory(category)" class="flexcenter link"
						:title="'Visa alla underkategorier till: ' + category.name">
						<b style="font-size:80%;margin-right:10px;"
							:class="this.selectedCategory?.categoryId == category.categoryId ? 'selected' : 'not-selected'">
							{{ category.name }}
						</b>
					</div>
				</div>


				<div v-if=" !this" class="flexcenter">
					<div style="background:yellow;padding:5px;">
						{{ this.selectedCategory?.name }} - ({{ this.selectedCategory?.productList?.length }}) - sum: {{
							this.prouductCountLabel(this.selectedCategory) }}
					</div>
				</div>


				<!-- grid med kategori-listan alla kompakt -->
				<div v-if="this" id="categoryGridViewAll" class="flexcenter"
					style="flex-direction:row;flex-wrap:wrap;background:transparent;padding:0px;margin-top:10px;align-items:start;">

					<div v-for="category in this.sortCategoryList(this.collectedCategoryList)" :key="category.categoryId"
						:title="category.productList?.length + '/' + this.prouductCountLabel(category)"
						style="padding:0px;border-radius: 5px;margin-bottom:5px;min-width:250px;" class="flexcenter link"
						@click="this.categorySelected(category)">

						<div @click.stop="this.categorySelected(category)" class="flexcenter category"
							:title="this.categoryTitle(category)" style="margin-right:5px;margin-bottom:5px;">
							{{ category.name }}
						</div>


					</div>
				</div>

				<!-- categoryTable används ej-->
				<div v-if="!this" id="categoryTable" class="flexcenter"
					style="flex-wrap:wrap;border:1px solid red;align-items:start; ">


					<div v-for="colIndex in Math.ceil(this.collectedCategoryList?.length / 5)" :key="colIndex"
						style="border:1px solid blue;">
						<b>ColIndex: {{ colIndex - 1 }} </b>

						<div
							v-for="category in this.sortCategoryList(this.collectedCategoryList).slice((colIndex - 1) * 5, ((colIndex - 1) * 5) + 5)"
							:key="category.categoryId" :title="category.productList?.length + '/' + this.prouductCountLabel(category)"
							style="padding:0px;border-radius: 5px;margin-bottom:5px;" class="flexcenter link"
							@click="this.categorySelected(category)">

							<div @click.stop="this.categorySelected(category)" class="flexcenter category"
								:title="this.categoryTitle(category)" style="margin-right:5px;margin-bottom:5px;">
								{{ category.name }}
							</div>


						</div>
					</div>
				</div>


				<!-- grid med kategori-listan -->

				<div id="categoryGridView"
					v-if="!this.selectedCategory && this.currentCategory?.categoryList && this.currentCategory?.categoryList?.length > 0"
					style="margin-top:10px;" class="">


					<div v-for="category in this.sortCategoryList(this.currentCategory?.categoryList)" :key="category.categoryId"
						style="padding:3px;margin-bottom:5px;font-size:100%;margin-right:10px;min-width:150px;"
						@click.stop="this.categorySelected(category)" class="category link">

						<div :title="this.categoryTitle(category)" class="flexcenter">
							<b style="color:black;font-size:80%;"> {{
								category.name }}</b>
							<Icon fileName="w3_chevron_right_light" style="height:10px;width:6px;margin-left:2px;" />

						</div>

						<!-- cell med underkategorier -->
						<div class="categoryListResult" style="border:0px solid black;margin-top:5px;">

							<div v-if="category.categoryList && category.categoryList.length > 0">

								<div v-for="category2 in this.sortCategoryList(category.categoryList)" :key="category2.categoryId" class="link">


									<div @click.stop="this.categorySelected(category2)" class="flexcenter category"
										:title="this.categoryTitle(category2)">
										{{ category2.name }}
									</div>

									<div v-if="category2.categoryList?.length > 0">

										<!-- level 3 -->
										<div v-for="category3 in this.sortCategoryList(category2.categoryList)" :key="category3.categoryId"
											style="background:transparent;" class="link">

											<div @click.stop="this.categorySelected(category3)" class="flexcenter category"
												:title="this.categoryTitle(category3)">
												- {{ category3.name }}
											</div>

											<div v-if=" category3.categoryList?.length> 0">

												<!-- level 4 -->
												<div v-for="category4 in this.sortCategoryList(category3.categoryList)" :key="category4.categoryId" style=""
													class="link">

													<div @click.stop="this.categorySelected(category4)" class="flexcenter category"
														:title="this.categoryTitle(category4)">
														&nbsp;&nbsp;- {{ category4.name }}
													</div>

													<div v-if="category4.categoryList?.length > 0">

														<!-- level 5 -->
														<div v-for="category5 in this.sortCategoryList(category4.categoryList)" :key="category5.categoryId"
															style="" class="link">

															<div @click.stop="this.categorySelected(category5)" class="flexcenter category"
																:title="this.categoryTitle(category5)">
																&nbsp;&nbsp;&nbsp;&nbsp;- {{ category5.name }}
															</div>

														</div>

													</div>
												</div>



											</div>
										</div>

									</div>
								</div>
							</div>
							<div v-else @click.stop="this.categorySelected(category)" class="link">

								<div @click.stop="this.categorySelected(category)" class="flexcenter category"
									:title="this.categoryTitle(category)">
									{{ category.name }}
								</div>

							</div>

						</div>
					</div>


				</div>
				<div v-if="!this.currentCategory?.categoryList || this.currentCategory?.categoryList?.length == 0">
					Inga underkateorier
				</div>
			</div>



		</div>


	</div>
</template>
<script>
//import listHelper from '../../helper/list-helper';
import listHelper from '../../helper/list-helper';
import { STORE_GETTER } from '../../store/store';

import { routerMixin } from "@/mixins/routerMixin.js";
import { categoryMixin } from "@/mixins/categoryMixin.js";
import { productSearchMixin } from "@/mixins/productSearchMixin.js";

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
import categoryHelper from "@/helper/category-helper.js";
import Card from '../../components/Card.vue';
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "PopoverCategoryView",
	components: { Card },
	mixins: [routerMixin, productSearchMixin, categoryMixin],
	props: {

	},
	data() {
		return {
			selectedCategory: null,
			selectedStartCategory: null,
			filter: null,
			showCategory1: false,
			showCategory2: false,
			
		};
	},
	computed: {

		/*baseCategoryModel() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel) {
				return baseModel.categoryModel
			}

			return null;
		},*/




		category1(){

			//const categoryId = this.selectedCategory?.categoryId // vald kategori id
			const categoryId = this.selectedStartCategory?.pathIdList[0];
			if (categoryId){
				const node = categoryHelper.findInCategoryTree(categoryId, this.baseCategoryModel?.categoryTree)
				return node;
			}

			return null;
			
		},

		currentCategory(){
			if(this.selectedCategory){
				return this.selectedCategory
			}

			return this.selectedStartCategory

		},
		categoryListSearch(){

			var categoryList = this.baseCategoryModel?.categoryList?.filter(category => category !== null)

			
			/*if (categoryListX && this.filter && this.filter.length > 0){
				categoryListX = listHelper.filter(this.filter, categoryListX)
			}*/

			if (categoryList){
				//categoryListX = categoryListX.filter(category => category.categoryId == 4)
				categoryList = categoryList.filter(category => {
					return listHelper.filter(category.search, this.filter);
				})
			}

			return categoryList
			
		},
		collectedCategoryList(){

			const category = this.selectedCategory
			var categoryList = [];

			if (category){
				//categoryList = this.sumProductForCategory2(category);
				categoryList = category.categoryList
			}

			return categoryList;

		},


	

	},
	watch: {
		selectedStartCategory: function (){

			this.selectedCategory = null;

		},
		selectedCategory: function(category){
			console.log('FP: selectedCategory: ', category);
			//this.$emit('searchCategorySelected', category)
			
		}
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		categorySelected(category){

			console.log('FP: category: ', category);

			this.searchCategorySelected(category);
			
			// fiska fram rätt product-type 
			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

			if (!productType){ // om ingen kategori är satt. 
				
				const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);
				this.routerShowProductListForUrlKey(productTypeUrlKey);


			}else{
				this.$emit('popoverCategoryClosed')
				this.routerShowProductList()
			}


		},
		searchCategoryIdSelected(categoryId){ // FP: letar upp rätt kategori i trädet
			console.log('FP: categoryId: ', categoryId);

			const category = categoryHelper.findInCategoryTree(categoryId, this.baseCategoryModel?.categoryTree)
			
			if (category){
				this.categorySelected(category);
			}

		},

		categoryTitle(category){
			//return "Visa alla produkter i kategori: " + category.name + ", antal: " + this.sumProduct(category);
			return "Visa alla produkter i kategori: " + category.name + ", antal: " + this.prouductCountLabel(category);
			
		},
		hideAllPageMenu(){

		},
		setSelectedCategory(category){
			if (this.selectedCategory && this.selectedCategory.categoryId == category.categoryId){
				this.selectedCategory = null;
			}else{
				this.selectedCategory = category
			}
		},
		/*
		sumProduct(category){

			if (!category){
				return "??";
			}

			//var sum = this.sumProductForCategory(category)
			//return "C: " + sum

			var list = this.sumProductForCategory2(category);

			console.log('FP: sumProduct length: ', list.length);
			console.log('FP: sumProduct, ', list);

			var sum = 0 

			list?.forEach(category => {
				sum += category?.productList?.length
				
			})

			return sum;

		},*/

/*
		sumProductForCategory2(category){

			let categoryList = [category]

			console.log("FP: rec visit: " + category.path + ":" + category.categoryList?.length );
			

			category?.categoryList?.forEach(category => {
				
				categoryList = categoryList.concat(this.sumProductForCategory2(category))
			})


			return categoryList;


		},*/

/*
		sumProductForCategory(category){

			let count = category?.productList?.length

			

			category?.categoryList?.forEach(category => {
				count += this.sumProductForCategory(category)
			})

			return count;


		},*/


		/*sum(category){



			if (category && category.categoryList && category.categoryList.length > 0){

				for (var i = 0; i < category.categoryList.length; i++) { 

					const childCategory = category.categoryList[i];



					return category.productList.length + this.sum(childCategory);
					
				}

			}else{

				if (category && category.productList && category.productList.length > 0){
					return category.productList.length;
				}else{
					return 0;
				}
			}

		},*/
		
		

	},
	created() {

	}
};
</script>



<style scoped>

div#categoryGridView{
	display: grid;
	grid-template-columns: repeat(5, calc((100% - 35px) / 5));
	grid-row: auto;
	column-gap: 10px;
	row-gap: 5px;
	border: 0px solid transparent;
	align-items: stretch;

}

div#categoryGridView > div.category {
	border-bottom:1px solid var(--grey-4);
}

@media (max-width: 1068px) {

	div#categoryGridView {
			grid-template-columns: auto auto auto;
		
		}

}

@media (max-width: 768px) {

	@media (max-width: 1068px) {
	
			div#categoryGridView {
				grid-template-columns: auto auto;
	
			}
	
		}

}

/* ================ */

div.cateBox{
	background-image: url("~@/assets/category/category.jpg");
	width:200px;
	height:200px;
	aspect-ratio: 1 / 1;
		object-fit: contain;
	background-size: cover;
}

div#startCategoryGridLow.flexcenter > div{
	background:transparent; 
	border-radius: 5px;;
}

div#startCategoryGridLow.flexcenter div.selected {
	background: var(--grey-2);
}

div#startCategoryGridLow.flexcenter div:hover {
	background: var(--grey-3);
}

div#selectedStartCategoryGrid.flexcenter div.flexcenter.link b{
	color:grey;
}

div#selectedStartCategoryGrid.flexcenter div.flexcenter.link b.selected {
	color: black;
}

div#selectedStartCategoryGrid.flexcenter div.flexcenter.link b:hover {
	color: black;
}

div.categoryListResult div.category,
div#categoryGridViewAll div.category{
	color:grey;
	font-size:90%;
	font-weight:bold;
	margin-bottom:5px;
}

div#categoryGridViewAll div.category{
	color: grey;
	font-size: 90%;
	font-weight: bold;
	margin-bottom: 5px;
}

div.categoryListResult div.category:hover,
div#categoryGridViewAll div.category:hover {
	color: black;
}

div#startCategoryGrid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%/5, max(350px, 100%/7)), 1fr));
	grid-row: auto;
	column-gap: 10px;
	row-gap: 5px;
	border: 0px solid transparent;
	align-items: stretch;

}

div#startCategoryGrid div.card {
	min-width: 200px;
	max-height: 250px;
	min-height: 300px;
	max-width: 350px;
}

@media (max-width: 1068px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto auto;
	}

	div#startCategoryGrid div.card {
		min-height: 250px;
	}

}

@media (max-width: 768px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto;
	}

	div#startCategoryGrid div.card {
		min-height: 350px;
	}

}


</style>